((app, ng) => {

    app.component("toDos",
        {
            templateUrl: "/App/Dashboard/Tiles/ToDos/to-dos.template.html",
            controller: toDosController,
            bindings: {
                currentUser: "<",
                parentToDos: "<" // Allows subusers to see tasks and appointments of their parent users
            }
        });

    function toDosController($q, scheduledTaskApi, appointmentApi, moment, badScheduledTasks) {
        const $ctrl = this;
        

        $ctrl.$onInit = () => {
            $ctrl.tasks = [];
            $ctrl.appointments = [];
            // converting all date objects to moment to avoid comparing different date formats
            $ctrl.today = moment().startOf('day');
            $ctrl.tomorrow = moment(moment().add(1, 'days')).startOf('day');
            $ctrl.yesterday = moment(moment().subtract(1, 'days')).endOf('day');
            $ctrl.ui.loading = true;

            const promises = [
                // moved bad task hotfix to controller to better control order of event
                $ctrl.getIncompleteTasks($ctrl.currentUser.Id)
                    .then(res => res.filter(task => badScheduledTasks.indexOf(task.Id) === -1 && ($ctrl.parentToDos || task.AssignedUserId === $ctrl.currentUser.Id))),
                $ctrl.getUserAppointments($ctrl.currentUser.Id, null, $ctrl.today.year(), $ctrl.today.month() + 1) // Add 1 to month because moment offsets their month's by 1, ie jan = 0, feb = 2, etc.
            ];

            $q.all(promises)
                .then(responses => {
                    let _tasks = [];
                    [_tasks, $ctrl.appointments] = responses;

                    _tasks.forEach(task => {
                        let dueDate = moment(task.DueDate);
                        let dueDateMidnight = moment(task.DueDate).startOf('day');

                        // task.isAllDay is implicit by checking if task's due date is set to midnight
                        task.isAllDay = dueDate.isSame(dueDateMidnight) ? true : false;

                        // if due date is between the end of yesterday (11:59:59.99) and the start of tomorrow (midnight)
                        if (dueDate.isAfter($ctrl.yesterday) && dueDate.isBefore($ctrl.tomorrow)) {
                            $ctrl.tasks.push(task);
                        }
                        // if due date is older than start of today (midnight)
                        else if (dueDate.isBefore($ctrl.today))
                            $ctrl.overdueTasks.push(task);
                    });

                    $ctrl.appointments = $ctrl.appointments
                        .filter(appointment => {
                            // filter out events that do not occur on today
                            const appointmentStartDate = moment(appointment.StartDate);
                            const appointmentEndDate = moment(appointment.EndDate);
                            return appointmentStartDate.isBefore(moment().endOf('day')) && appointmentEndDate.isAfter(moment().startOf('day')) && ($ctrl.parentToDos || appointment.AssignedUserIds.includes($ctrl.currentUser.Id));
                        })
                        .map(appoinment => {
                            const apptCopy = appoinment;
                            apptCopy.multiDay = appoinment.StartDate.toDateString() !== appoinment.EndDate.toDateString(); // See if appoinment spans multiple days
                            return apptCopy;
                        });
                })
                .finally(() => $ctrl.ui.loading = false);
        };

        const getIncompleteTasks = (userId) => {
            return scheduledTaskApi.getUserIncompleteTasks(userId)
                .then(tasks => {
                    return tasks;
                });
        };

        const getUserAppointments = (userId, nextPageToken, year, month) => {
            return appointmentApi.getUserAppointments(userId, nextPageToken, year, month)
                .then(appointments => {
                    if (!appointments.NextPage) { return appointments; }

                    return getUserAppointments(userId, appointments.NextPage, year, month)
                        .then(recursiveAppts => { return appointments.concat(recursiveAppts); });
                });
        };

        ng.extend($ctrl,
            {
                ui: {
                    loading: false
                },
                getIncompleteTasks,
                getUserAppointments,
                tasks: [],
                overdueTasks: []
            });
    }

})(window.app, window.angular);